module.exports = __webpack_public_path__ + "static/media/stay-assured.5630e4c1.svg";